const kmToMail = 0.6213712

function DEG2RAD(degrees) {
  return degrees * 0.01745327
}

function distanceFromPoints(lat1, lng1, lat2, lng2, unit) {
  if (lat1 === lat2 && lng1 === lng2) return 0
  const lat1rad = DEG2RAD(lat1);
  const lat2rad = DEG2RAD(lat2);
  return (unit === 'km' ? 1 : kmToMail) * Math.acos(Math.sin(lat1rad) * Math.sin(lat2rad) + Math.cos(lat1rad) * Math.cos(lat2rad) * Math.cos(DEG2RAD(lng2) - DEG2RAD(lng1))) * 6378.1;
}

export default distanceFromPoints
